export const checkerStatusKey = {
  STATUS: 'status',
  COMMENT: 'comment',
  DATA_SOURCE: 'dataSource',
  MANUAL: 'manual',
  BULK_UPLOAD: 'bulkUpload',
  REJECTED: 'rejected',
  ACCEPTED: 'accepted',
  IN_REVIEW: 'inReview'
};
export const checkerStatusLabel = {
  STATUS: 'Status',
  COMMENT: 'Comment',
  STATUS_COMMENTS: 'Status & Comments',
  DATA_SOURCE: 'DataSource',
  MANUAL: 'Manual Entry',
  BULK_UPLOAD: 'Bulk Upload',
  REJECTED: 'Rejected',
  ACCEPTED: 'Accepted',
  IN_REVIEW: 'In-Review'
};
